module.exports = __webpack_public_path__ + "static/media/floor4_zone_v3.4ac6c45a.png";